var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNewMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49933 0C8.87706 0 8.37433 0.502734 8.37433 1.125V1.8C5.80792 2.32031 3.87433 4.59141 3.87433 7.3125V7.97344C3.87433 9.62578 3.26612 11.2219 2.16925 12.4594L1.90909 12.7512C1.61378 13.0816 1.54347 13.5563 1.72276 13.9605C1.90206 14.3648 2.30636 14.625 2.74933 14.625H16.2493C16.6923 14.625 17.0931 14.3648 17.2759 13.9605C17.4587 13.5563 17.3849 13.0816 17.0896 12.7512L16.8294 12.4594C15.7325 11.2219 15.1243 9.6293 15.1243 7.97344V7.3125C15.1243 4.59141 13.1907 2.32031 10.6243 1.8V1.125C10.6243 0.502734 10.1216 0 9.49933 0ZM11.0919 17.3426C11.5138 16.9207 11.7493 16.3477 11.7493 15.75H9.49933H7.24933C7.24933 16.3477 7.48487 16.9207 7.90675 17.3426C8.32862 17.7645 8.90167 18 9.49933 18C10.097 18 10.67 17.7645 11.0919 17.3426Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 3.75,
    r: 3.75,
    fill: "#D62516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNewMob);
export default __webpack_public_path__ + "static/media/notification_new_mob.2df6cf9c3ea2acadfef72219da75fa11.svg";
export { ForwardRef as ReactComponent };